import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Resolve relative storage URLs (e.g. "/api/files/...") to absolute backend URLs
export function resolveImg(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

// session-id (browser session for analytics)
function getOrCreateSessionId() {
  try {
    let sid = localStorage.getItem("bls_session_id");
    if (!sid) {
      sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("bls_session_id", sid);
    }
    return sid;
  } catch {
    return null;
  }
}

export async function trackView(path) {
  try {
    await api.post("/track", {
      path,
      referrer: document.referrer || null,
      session_id: getOrCreateSessionId(),
    });
  } catch {
    /* silent */
  }
}
